export const PER_PAGE = 20;
export const TABLE_PER_PAGE = 20;
export const HOME_PAGE_PER_PAGE = 8;
export const SEO_STATIC = {
  locale: "en_US",
  type: "website",
  site_name: "Million Experts",
};
